module.exports = __webpack_public_path__ + "img/barrel-tavern-7.30.317a377d.jpeg";